export default __webpack_public_path__ + "static/media/sa-white.02a53dbb.svg";